Original: contact-dropdown-item-contextual-popover contact="contact">/contact-dropdown-item-contextual-popover>

<template>
<!--  <Loader v-if="loading"/>-->
  <dl v-if='context.type === "Group"'>
    <dt>
    <span v-if="context.is_family">
      Family Members
    </span>
    <span v-if="!context.is_family">
      Group Members
    </span>
    </dt>
    <dd v-for="relation in context.relations" v-if="!loading">
      {{relation.full_name}}
    </dd>
    <dd v-if="loading">
      Loading…
    </dd>
  </dl>
  <dl>
    <dt>Programs</dt>
    <dd v-if="loading">
      Loading…
    </dd>
    <template v-else>
      <dd v-if="context.programNames.length" v-for="p in context.programNames">
        {{p}}
      </dd>
      <dd v-else>
        None
      </dd>
    </template>
  </dl>
  <dl>
    <dt>
      {{ $t('Assigned Staff') }}
    </dt>
    <dd v-if="loading">
      Loading…
    </dd>
    <dd v-else>
      <div v-if="context.contact_users.length">
        <ul class="unstyled">
          <li v-for="contact_user in context.contact_users">
            <vue-avatar type="avatar_tiny" :user="contact_user.user" width="15" />
            <span>{{contact_user.user.full_name}}</span>
          </li>
        </ul>
      </div>
      <div v-else>
        None
      </div>
    </dd>
  </dl>
  <dl v-if='context.type !== "Group" && (context.inverse_relations||[]).filter(r=>r.is_family).length > 0'>
    <dt>
      Family
    </dt>
    <dd v-for="ir in context.inverse_relations.filter(r=>r.is_family)">
      <span v-if="ir.is_family">
        {{ir.group_name}} Family
      </span>
      <span v-if="(context.inverse_relations.filter(r=>!r.is_family)).length > 0"></span>
    </dd>
  </dl>
  <dl v-if='context.type !== "Group" && (context.inverse_relations||[]).filter(r=>!r.is_family).length > 0'>
    <dt>
      Groups
    </dt>
    <dd v-for="ir in context.inverse_relations.filter(r=>!r.is_family)">
      {{ir.group_name}}
    </dd>
  </dl>
  <div id="tailwind" v-if="!loading">
    <template v-if="context.popoverFields.length < 1">
      <template v-for="ccst in context.ccsts.filter(c=>c.contact_sub_type.standard)" :key="ccst.id">
        <render-fields :ccst="ccst" :custom-fields="false"/>
      </template>
    </template>
    <template v-else>
      <template v-for="ccst in context.ccsts" :key="ccst.id">
        <render-fields :ccst="ccst" :custom-fields="true"/>
      </template>
    </template>
  </div>

</template>
<script>
import Loader from '../../common/_loader.vue';
import './contextual-popover.style.scss';
import VueAvatar from '../../common/_avatar.vue';
import RenderFields from './_render_fields.vue'
export default {
  components: { VueAvatar, Loader, RenderFields },
  props: {
    contact: {type: Object, required: true},
    isOpen: {type: Boolean, required: true},
  },
  data: ()=>({
    loading: true,
    context: {},
  }),
  provide() {
    return {sidebar: true,}
  },
  created () {
    this.loadContact()
  },
  methods: {
    loadContact(){
      return this.axios.get(`/contacts/${this.contact.uid}`).then(resp=>{
        const data = resp.data
        this.context = {...data, ...this.generateContext(data)}
        this.loading = false
      })
    },
    generateContext(data){
      const ccsts = data.contact_contact_sub_types
          .filter((item) => item.status === 'active' && item.form_result !== null);
      const relations = data.relations;
      const programNames = this.getProgramNames(data);
      const popoverFields = this.getFields(data);

      return {
        ccsts,
        relations,
        programNames,
        popoverFields,
        inverse_relations: data.inverse_relations || []
      };
    },

    getProgramNames(contact) {
      const programEnrollments = contact.program_enrollments || [];
      const enrolledPrograms = programEnrollments.filter(enrollment => enrollment.status === 'enrolled');
      return enrolledPrograms.map(enrollment => enrollment.program.name);
    },

    // getFields :: Contact -> [Field]
    getFields(contact) {
      const contactSubTypes = contact.contact_contact_sub_types || [];
      return contactSubTypes
          .flatMap(subType => subType.contact_sub_type.field_group.fields || [])
          .filter(field => field.datahash && field.datahash.sidebar === true);
    },
  }
}
</script>
<style lang="scss" scoped>
dl{
  margin: 0 !important;
}
</style>